export const homeLeaderLines = (
  widthDim,
  refs
) => {
  const {
    blanca,
    emely,
    john,
    alfredo,
    homeRef,
    reportBtnRef,
    exploreBtnRef,
    pathwaysBtnRef,
    addmeBtnRef
  } = refs;

  const LeaderLine = window.LeaderLine;
  let size = widthDim > 1150 ? 'lrg' : 'sm';

  const lineConfig = {
    color: '#d7135b',
    dash: true,
    endPlug: 'behind',
    path: 'grid'
    // path: 'fluid'
  }

  const plugOrientations = (start, stop) => {
    return {
      startSocket: start,
      endSocket: stop
    }
  }

  let startSocketGravity;
  let endSocketGravity;
  let lines = {};

  let firstStart = size === 'lrg' ? homeRef : LeaderLine.pointAnchor(
    homeRef,
    {
      x: '5%',
      y: '100%'
    }
  );

  endSocketGravity = size === 'lrg' ? [0, 0] : [-5, 0];
  lines.firstLine = new LeaderLine(
    firstStart,
    reportBtnRef,
    {
      ...lineConfig,
      ...plugOrientations('bottom', 'left'),
      startPlug: 'disc',
      startPlugSize: 3,
      endSocketGravity
    }
  );

  startSocketGravity = size === 'lrg' ?
    [100, 0]
    :
    [(widthDim - ( 2 * reportBtnRef.getBoundingClientRect().x ) - reportBtnRef.getBoundingClientRect().width - 15), 0];

  lines.secondLine = new LeaderLine(
    reportBtnRef,
    exploreBtnRef,
    {
      ...lineConfig,
      ...plugOrientations('right', 'right'),
      startSocketGravity,
    }
  );

  if (widthDim > 350) {
    startSocketGravity = size === 'lrg' ? [-160, 0] : [-5, 0];
    let thirdEnd = size === 'lrg' ? 
      LeaderLine.pointAnchor(
        blanca,
        {
          x: 0,
          y: '79%'
        }
      )
      :
      pathwaysBtnRef;

    lines.thirdLine = new LeaderLine(
      exploreBtnRef,
      thirdEnd,
      {
        ...lineConfig,
        ...plugOrientations('left', 'left'),
        startSocketGravity,
      }
    );

    let fourthStart = size === 'lrg' ?
      LeaderLine.pointAnchor(
        blanca,
        {
          x: '100%',
          y: '79%'
        }
      )
      :
      pathwaysBtnRef

    let fourthEnd = size === 'lrg' ?
      pathwaysBtnRef
      :
      LeaderLine.pointAnchor(
        emely,
        {
          x: '100%',
          y: '79%'
        }
      );

    let fourthOrientation = size === 'lrg' ?
      plugOrientations('right', 'left')
      :
      plugOrientations('right', 'right')

    endSocketGravity = size === 'lrg' ? [0, 0] : [50, 0];
    lines.fourthLine = new LeaderLine(
      fourthStart,
      fourthEnd,
      {
        ...lineConfig,
        ...fourthOrientation,
        path: size === 'lrg' ? 'straight' : 'grid',
        endSocketGravity
      }
    );
  }

  let fifthStart = size === 'lrg' ?
    pathwaysBtnRef
    :
    LeaderLine.pointAnchor(
      emely,
      {
        x: 0,
        y: '79%'
      }
    )

  let fifthEnd = size === 'lrg' ?
    LeaderLine.pointAnchor(
      emely,
      {
        x: '100%',
        y: '60%'
      }
    )
    :
    LeaderLine.pointAnchor(
      alfredo,
      {
        x: 0,
        y: '79%'
      }
    );

  let fifthOrientation = size === 'lrg' ?
    plugOrientations('right', 'right')
    :
    plugOrientations('left', 'left')

  endSocketGravity = size === 'lrg' ? [50, 0] : [-5, 0];
  lines.fifthLine = new LeaderLine(
    fifthStart,
    fifthEnd,
    {
      ...lineConfig,
      ...fifthOrientation,
      endSocketGravity
    }
  );

  let sixthStart = size === 'lrg' ?
    LeaderLine.pointAnchor(
      emely,
      {
        x: 0,
        y: '60%'
      }
    )
    :
    LeaderLine.pointAnchor(
      alfredo,
      {
        x: '100%',
        y: '79%'
      }
    )

  let sixthEnd = size === 'lrg' ?
    john
    :
    LeaderLine.pointAnchor(
      blanca,
      {
        x: '100%',
        y: '79%'
      }
    );

  let sixthOrientation = size === 'lrg' ?
    plugOrientations('left', 'top')
    :
    plugOrientations('right', 'right')

  startSocketGravity = size === 'lrg' ? [0, 0] : [5, 0];
  lines.sixthLine = new LeaderLine(
    sixthStart,
    sixthEnd,
    {
      ...lineConfig,
      ...sixthOrientation,
      startSocketGravity
    }
  );

  let seventhStart = size === 'lrg' ?
    LeaderLine.pointAnchor(
      john,
      {
        x: '100%',
        y: '80%'
      }
    )
    :
    LeaderLine.pointAnchor(
      blanca,
      {
        x: 0,
        y: '79%'
      }
    )

  let seventhEnd = size === 'lrg' ?
    LeaderLine.pointAnchor(
      alfredo,
      {
        x: '100%',
        y: '80%'
      }
    )
    :
    LeaderLine.pointAnchor(
      john,
      {
        x: 0,
        y: '79%'
      }
    );

  let seventhOrientation = size === 'lrg' ?
    plugOrientations('right', 'right')
    :
    plugOrientations('left', 'left')

  endSocketGravity = size === 'lrg' ? [50, 0] : [-5, 0];
  lines.seventhLine = new LeaderLine(
    seventhStart,
    seventhEnd,
    {
      ...lineConfig,
      ...seventhOrientation,
      endSocketGravity
    }
  );

  if (widthDim > 350) {
    let eigthStart = size === 'lrg' ?
      LeaderLine.pointAnchor(
        alfredo,
        {
          x: 0,
          y: '80%'
        }
      )
      :
      LeaderLine.pointAnchor(
        john,
        {
          x: '100%',
          y: '79%'
        }
      )

    let eigthOrientation = size === 'lrg' ?
      plugOrientations('left', 'right')
      :
      plugOrientations('right', 'right')

    // endSocketGravity = size === 'lrg' ? [200, 0] : [5, 0];
    endSocketGravity = size === 'lrg' ?
      [200, 0]
      :
      [(widthDim - ( 2 * addmeBtnRef.getBoundingClientRect().x ) - addmeBtnRef.getBoundingClientRect().width) - 15, 0];
    lines.eigthLine = new LeaderLine(
      eigthStart,
      addmeBtnRef,
      {
        ...lineConfig,
        ...eigthOrientation,
        endSocketGravity
      }
    );
  }
  return lines;
}


export const pathwaysLeaderLines = (
  windowWidth,
  refs
) => {
  const {
    heroRef,
    directoryBtnRef,
    pathsRef
  } = refs;

  const LeaderLine = window.LeaderLine;

  const lineConfig = {
    color: '#d7135b',
    dash: true,
    endPlug: 'behind',
    path: 'grid'
  }

  const plugOrientations = (start, stop) => {
    return {
      startSocket: start,
      endSocket: stop
    }
  }

  let lines = {};

  lines.firstLine = new LeaderLine(
    heroRef,
    directoryBtnRef,
    {
      ...lineConfig,
      ...plugOrientations('left', 'left'),
    }
  );

  let secondEnd = windowWidth > 1150 ? pathsRef : LeaderLine.pointAnchor(
    pathsRef,
    {
      x: '95%',
      y: 0
    }
  );

  lines.secondLine = new LeaderLine(
    directoryBtnRef,
    secondEnd,
    {
      ...lineConfig,
      endPlugSize: 3,
      endPlug: 'disc',
      ...plugOrientations('right', 'top'),
      startSocketGravity: 0
    }
  );

  return lines;
}


export const reportLeaderLines = (
  windowWidth,
  refs
) => {
  const {
    heroRef,
    reportBtnRef,
    quoteRef,
    gratitudeRef,
    nonopGratisLeftRef,
    nonopGratisRightRef
  } = refs;

  const LeaderLine = window.LeaderLine;

  const lineConfig = {
    color: '#d7135b',
    dash: true,
    endPlug: 'behind',
    path: 'grid'
  }

  const plugOrientations = (start, stop) => {
    return {
      startSocket: start,
      endSocket: stop
    }
  }

  let lines = {};

  lines.firstLine = new LeaderLine(
    heroRef,
    reportBtnRef,
    {
      ...lineConfig,
      ...plugOrientations('right', 'left'),
    }
  );

  let secondEnd = windowWidth > 1150 ? quoteRef : LeaderLine.pointAnchor(
    quoteRef,
    {
      x: '95%',
      y: 0
    }
  );

  lines.secondLine = new LeaderLine(
    reportBtnRef,
    secondEnd,
    {
      ...lineConfig,
      endPlugSize: 3,
      endPlug: 'disc',
      ...plugOrientations('right', 'top'),
      startSocketGravity: 0
    }
  );


  lines.thirdLine = new LeaderLine(
    nonopGratisLeftRef,
    gratitudeRef,
    // LeaderLine.pointAnchor(
    //   gratitudeRef,
    //   {
    //     x: '-1%',
    //     y: windowWidth < 1150 ? '55%' : '28%'
    //   }
    // ),
    {
      ...lineConfig,
      ...plugOrientations('right', 'left'),
      startSocketGravity: 0
    }
  );

  lines.forthLine = new LeaderLine(
    // LeaderLine.pointAnchor(
    //   gratitudeRef,
    //   {
    //     x: '101%',
    //     y: windowWidth < 1150 ? '55%' : '28%'
    //   }
    // ),
    gratitudeRef,
    nonopGratisRightRef,
    {
      ...lineConfig,
      ...plugOrientations('right', 'left'),
      startSocketGravity: 0
    }
  );

  return lines;
}

export const addArc = (pathData, radius) => {
  let reL = /^L ?([\d.\-+]+) ([\d.\-+]+) ?/,
    newPathData, curXY, curDir, newXY, newDir,
    sweepFlag, arcXY, arcStartXY;

  const getDir = (xy1, xy2) => {
    if (xy1.x === xy2.x) {
      return xy1.y < xy2.y ? 'd' : 'u';
    } else if (xy1.y === xy2.y) {
      return xy1.x < xy2.x ? 'r' : 'l';
    }
    throw new Error('Invalid data');
  }

  const captureXY = (s, x, y) => {
    newXY = {x: +x, y: +y};
    return '';
  }

  const offsetXY = (xy, dir, offsetLen, toBack) => {
    return {
      x: xy.x + (dir === 'l' ? -offsetLen : dir === 'r' ? offsetLen : 0) * (toBack ? -1 : 1),
      y: xy.y + (dir === 'u' ? -offsetLen : dir === 'd' ? offsetLen : 0) * (toBack ? -1 : 1)
    };
  }

  pathData = pathData.trim().replace(/,/g, ' ').replace(/\s+/g, ' ')
    .replace(/^M ?([\d.\-+]+) ([\d.\-+]+) ?/, function(s, x, y) {
      curXY = {x: +x, y: +y};
      return '';
    });
  if (!curXY) { throw new Error('Invalid data'); }
  newPathData = 'M' + curXY.x + ' ' + curXY.y;

  while (pathData) {
    newXY = null;
    pathData = pathData.replace(reL, captureXY);
    if (!newXY) { throw new Error('Invalid data'); }

    newDir = getDir(curXY, newXY);
    if (curDir) {
      arcStartXY = offsetXY(curXY, curDir, radius, true);
      arcXY = offsetXY(curXY, newDir, radius);
      sweepFlag =
        curDir === 'l' && newDir === 'u' ? '1' :
        curDir === 'l' && newDir === 'd' ? '0' :
        curDir === 'r' && newDir === 'u' ? '0' :
        curDir === 'r' && newDir === 'd' ? '1' :
        curDir === 'u' && newDir === 'l' ? '0' :
        curDir === 'u' && newDir === 'r' ? '1' :
        curDir === 'd' && newDir === 'l' ? '1' :
        curDir === 'd' && newDir === 'r' ? '0' :
        null;
      if (!sweepFlag) { throw new Error('Invalid data'); }
      newPathData += 'L' + arcStartXY.x + ' ' + arcStartXY.y +
        'A ' + radius + ' ' + radius + ' 0 0 ' + sweepFlag + ' ' + arcXY.x + ' ' + arcXY.y;
    }

    curXY = newXY;
    curDir = newDir;
  }
  newPathData += 'L' + curXY.x + ' ' + curXY.y;
  return newPathData;
}



// WEBPACK FOOTER //
// ./src/services/lineCreators.js